import { DEFAULT_BUSINESS_HOURS } from "@msuite/utils/incoming-invoices";
import { useTranslation } from "@msuite/ui/localization";
import { BusinessHoursEditor } from "@/components/business-hours";
import { useOrganizationSettings } from "@/hooks/use-organization-settings";

/** When the workspace is open — the hours an incoming invoice's receipt is moved into. */
export function WorkspaceFormBusinessHours() {
	/** Context */
	const { t } = useTranslation();

	/** Query */
	const { businessHours } = useOrganizationSettings();

	/** Render */
	return (
		<div className="v-stack gap-6">
			<p className="label">{t("organization.business_hours_hint")}</p>
			<BusinessHoursEditor inheritedHours={businessHours ?? DEFAULT_BUSINESS_HOURS} />
		</div>
	);
}
